
import  {Heading}  from "@chakra-ui/react";
import SkillCard from "./SkillCard";

export function Skill(){
    return (
        <div  id="skills">
        
       <Heading mb="50px">My Skills</Heading>
       
       <SkillCard />
       
        </div>
    )
}